import React from 'react';
import { Route } from 'react-router-dom';

const LayoutRoute = ({ component: Component, layout: Layout, carritoVisible, datosCotizador=null, ...rest }) => (
  
  <Route
  
    {...rest}
    render={props => (
      <Layout carritoVisible={carritoVisible}>
        <Component datosCotizador={datosCotizador} {...props} />
      </Layout>
    )}
  />
);

export default LayoutRoute;
